import { observer } from "mobx-react";
import React, { Component } from 'react';
import UserSettingsStore from 'Stores/userSettingsStore';
import LoadingIndicator from "Components/Common/LoadingIndicator";
import 'Styles/userSettings/synchronizingModal.scss';
import { GetTaskDescriptionByUserState, SynchronizingTask } from "Utils/CommonFunctions";
import Helper from "Utils/Helper";

class SynchronizingModal extends Component {
    render() {
        if (UserSettingsStore.synchronizing.task === SynchronizingTask.waitInSyncQueue)
            return (
                <div className='sync-content'>
                    На СМР запущен процесс повторной синхронизации активированных пользователей. Во время процесса запрещено вносить изменения в профиль пользователя. Дождитесь окончания...
                </div>
            );

        let taskDescriptionSpan = GetTaskDescriptionByUserState(UserSettingsStore.currentUserState);

        let processText = '';
        switch (UserSettingsStore.synchronizing.task) {
            case SynchronizingTask.loadDocuments:
            case SynchronizingTask.loadControlDocuments:
            case SynchronizingTask.loadVisaDocuments:
            case SynchronizingTask.loadSignDocuments:
            case SynchronizingTask.loadProjectDocuments:
                processText = 'Загружено ';
                break;
            case SynchronizingTask.removingUser:
            case SynchronizingTask.removingUserDl:
            case SynchronizingTask.removeConsiderationDocuments:
            case SynchronizingTask.removeControlDocuments:
            case SynchronizingTask.removeVisaDocuments:
            case SynchronizingTask.removeSignDocuments:
            case SynchronizingTask.removeProjectDocuments:
                processText = 'Удалено ';
                break;
        }

        let endText = 'РКПД';
        switch (UserSettingsStore.synchronizing.task) {
            case SynchronizingTask.loadDocuments:
            case SynchronizingTask.loadControlDocuments:
            case SynchronizingTask.removingUser:
            case SynchronizingTask.removingUserDl:
            case SynchronizingTask.removeConsiderationDocuments:
            case SynchronizingTask.removeControlDocuments:
                endText = 'РК';
                break;
        }

        let total = UserSettingsStore.synchronizing.documents.total;
        let loaded = UserSettingsStore.synchronizing.documents.loaded;
        let totalFull = UserSettingsStore.synchronizing.documents.totalFull;
        let loadedFull = UserSettingsStore.synchronizing.documents.loadedFull;

        let currentProccessedUserDlTitle = UserSettingsStore.currentUserState.currentProccessedUserDlTitle;

        let progressByFoldersIsRunningIndicator = (UserSettingsStore.synchronizing.documents.total > 0) == false;
        let progressTotalIsRunningIndicator = (UserSettingsStore.synchronizing.documents.totalFull > 0) == false;

        return (
            <div className='sync-content'>
                {
                    (
                        UserSettingsStore.currentUserState
                        &&
                        UserSettingsStore.currentUserState.task != SynchronizingTask.removingUser
                        &&
                        UserSettingsStore.currentUserState.task != SynchronizingTask.removingUserDl
                        &&
                        UserSettingsStore.currentUserState.currentProccessedUserDlId != null
                    )
                        ?
                        (
                            <div className="text-block-margin-bottom">
                                <div>Синхронизация:</div>
                                <div className="text-overflow-dotted user-dl-title">{Helper.StringTruncateToDisplayUserDlTitle(currentProccessedUserDlTitle)}</div>
                            </div>
                        )
                        : ""
                }
                {
                    taskDescriptionSpan
                        ?
                        <div className="text-block-margin-bottom">
                            Выполняется {taskDescriptionSpan}.<br />Пожалуйста, подождите...
                        </div>
                        : ""
                }
                {
                    (UserSettingsStore.synchronizing.inProgress != true ? "" : (
                        <div>
                            {
                                (progressByFoldersIsRunningIndicator) ? "" : (
                                    <div className='process-progress-text'>
                                        {(`${processText} ${loaded} из ${total} ${endText}`)}
                                    </div>
                                )
                            }
                            {
                                (progressByFoldersIsRunningIndicator && progressTotalIsRunningIndicator) ? "" : (
                                    <LoadingIndicator loaded={loaded}
                                        total={total}
                                        runner={progressByFoldersIsRunningIndicator} />
                                )
                            }
                            {
                                (progressTotalIsRunningIndicator) ? "" : (
                                    <div className='process-progress-text'>
                                        {(`Всего ${Math.floor(loadedFull / totalFull * 100)}%`)}
                                    </div>
                                )
                            }
                            <LoadingIndicator loaded={loadedFull}
                                total={totalFull}
                                runner={progressTotalIsRunningIndicator} />

                        </div>
                    ))
                }
            </div>
        );
    }
}

export default observer(SynchronizingModal);